import React, { Component, ErrorInfo, ReactNode } from "react";
import {ReactComponent as RocketDestroy} from 'assets/svgs/rocket_destroy.svg';
import { logErrorToMyService } from "helper";

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // console.error("Uncaught error:", error, errorInfo);
    logErrorToMyService(error, errorInfo.componentStack);
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback ? this.props.fallback : (
        <div className="h-screen flex flex-col pt-[140px] items-center">
            <RocketDestroy/>
            <h1 className="text-primary-title font-acorn font-bold text-[38px] 2xl:text-[40px] text-center">Oops Error Occurred</h1>
            <p className="text-center text-[16px] 2xl:text-[18px] text-gray-subTextHint font-medium">
            You are about to initiate a page for dev testing.<br/>Select a simulation below:
                {process.env.NODE_ENV === 'development' ? this.state.error?.message : ''}<br/>
                {process.env.NODE_ENV === 'development' ? this.state.error?.stack : ''}
            </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
